<template>
  <div class="jps-rights-summary jps-meta"
    :class="{
      'page-hina': isHina,
      'page-jps': isJps,
    }"
  >
    <BaseSectionContainer
      tag="div"
      size="narrow"
      class="copyright-global"
    >
      <BaseIcon
        name="mdi/help-circle-outline"
        class="jps-icon copyright-global-icon"
        size="size-none"
      />
      <div class="copyright-global-body">
        <h2 class="copyright-global-heading">
          <span>{{ ls(title) }}</span>
        </h2>
        <p
          v-if="!hideLicense && rights"
          class="copyright-global-description"
        >
          {{ ls(getRightDescription(rights)) }}
        </p>
      </div>
    </BaseSectionContainer>
    <template v-if="!hideLicense">
      <template v-if="rights && rights !== 'various'">
        <div class="cc-by">
          <UiRightsTag
            large
            class="rights-tag"
            :rights="rights"
            :rights-description="rightsDescription"
            :type="type"
            :data="data"
          />
        </div>

        <div class="license">
          <UiRightsLicenseSummary :rights="rights" />
        </div>
      </template>

      <BaseSectionContainer
        tag="div"
        size="narrow"
        class="specific-license"
        v-if="!isEmpty(rightsDescription)"
      >
        <h3 class="specific-license-heading cc-by">
          {{ lss('資料固有の条件', 'Specific Conditions') }}
        </h3>
        <p v-shtml="ls(rightsDescription)" />
      </BaseSectionContainer>
    </template>
  </div>
</template>

<script lang="ts" setup>
import vShtml from '~/directives/shtml'
import { useRightsData } from '~/components/ui/rights/useRightsData'

const { ls, lss } = useI18n()
const { getRightDescription } = useRightsData()
const { isJps, isHina } = useServiceType()

interface Props {
  title: LangString
  rights: string
  rightsDescription: LangString
  type: Key
  hideLicense?: boolean
  data?: { id: string }
}
const props = withDefaults(defineProps<Props>(), {
  hideLicense: false,
})
</script>

<style lang="scss" scoped>
@use '@/assets/styles/scss/vue' as *;

.jps-rights-summary {
  position: relative;
  background-color: $jps-gray-50;

  .copyright-global {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    // gap: 0 0.25rem;
    margin-bottom: 0;
    h2 {
      margin-bottom: calc(0.25rem * 2);
      column-gap: 0.25rem;
      @include is-tablet {
        margin: 0;
      }
    }
    > p {
      margin: 0.75rem 0;
      line-height: inherit;
    }
    .jps-icon {
      margin-right: calc(0.25rem * 2);
      @include is-tablet {
        margin-right: 22px;
      }
    }
    .copyright-global-icon {
      width: 4.5rem;
      height: 4.5rem;
    }
    .copyright-global-body {
      display: flex;
      flex-direction: column;
    }
    .copyright-global-heading {
      font-size: $size-6;
      font-weight: bold;
      margin: 0;
    }
    .copyright-global-description {
      font-size: $size-5;
    }
  }
  .license {
    padding-bottom: calc(0.25rem * 8);
    padding-left: calc(0.25rem * 3);
    @include is-tablet {
      padding-bottom: calc(0.25rem * 4);
      padding-left: 0;
    }
    .lisense-name {
      margin-left: calc(0.25rem * 2); margin-right: calc(0.25rem * 2);
      margin-bottom: calc(0.25rem * 12);
    }
  }
  .guideline {
    display: block;
    @include is-tablet {
      display: flex;
      align-items: stretch;
    }
    .guideline-contents {
      display: flex;
      justify-content: center;
      margin-bottom: calc(0.25rem * 2);
      .jps-icon {
        display: block;
        font-size: 3rem;
        cursor: pointer;
      }
      > div {
        min-width: 6.75rem;
        .heading {
          margin-bottom: 0.5rem;
          letter-spacing: 0;
        }
      }
    }
    .guideline-details {
      padding-left: 0;
    }
  }
  .jps-rights-summary-about {
    position: relative;
    background-color: $jps-gray-50;
    max-width: 100%;
    display: block;
    padding: 0;
    overflow: hidden;
    .jps-rights-summary-about-contents {
    }
  }
  .specific-license {
    margin-bottom: 2rem;
    text-align: center;
    .specific-license-heading {
      font-size: $size-7;
    }
    p, p a {
      overflow-wrap: anywhere;
    }
  }
  .license {
    display: flex;
    justify-content: center;
  }
  .rights-tag {
    margin-bottom: 2rem;
  }
  padding-bottom: 3rem;

  @include is-mobile {
    padding-top: 1.5rem;
    margin-bottom: 3rem;
    > * {
      padding: 0 0.75rem;
    }
  }

  @include is-tablet {
    padding: 3rem 0;
  }
}

.cc-by {
  text-align: center;
  margin-top: 1rem;
}

.page-hina {
  background-color: $hina-background-cream;

  .copyright-global {
    color: $jps-gray-700;

    * {
      color: $jps-gray-700;
    }
    .copyright-global-icon {
      width: 5.3125rem;
      height: 5.3125rem;
    }
    .copyright-global-body {
      gap: 0.5rem;
    }
    .copyright-global-description {
      font-size: $size-6;
    }
  }

  .specific-license {
    .specific-license-heading {
      font-size: $size-6;
      color: $jps-gray-700;
      margin-bottom: 0.5rem;
    }
    p, p a {
      overflow-wrap: anywhere;
    }
  }
}
</style>
